export const FETCH_RESTORE_DELETED_COMPANIES_REQUEST = 'FETCH_RESTORE_DELETED_COMPANIES_REQUEST'
export const FETCH_RESTORE_DELETED_COMPANIES_SUCCESS = 'FETCH_RESTORE_DELETED_COMPANIES_SUCCESS'
export const FETCH_RESTORE_DELETED_COMPANIES_FALUIRE = 'FETCH_RESTORE_DELETED_COMPANIES_FALUIRE'
